import { render, staticRenderFns } from "./zhizao.vue?vue&type=template&id=95927e44&scoped=true&"
import script from "./zhizao.vue?vue&type=script&lang=js&"
export * from "./zhizao.vue?vue&type=script&lang=js&"
import style0 from "./zhizao.vue?vue&type=style&index=0&lang=css&"
import style1 from "./zhizao.vue?vue&type=style&index=1&id=95927e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95927e44",
  null
  
)

export default component.exports